import { render, staticRenderFns } from "./JcomNationalBoardMembersAssign.vue?vue&type=template&id=3b82dc6b"
import script from "./JcomNationalBoardMembersAssign.vue?vue&type=script&lang=js"
export * from "./JcomNationalBoardMembersAssign.vue?vue&type=script&lang=js"
import style0 from "./JcomNationalBoardMembersAssign.vue?vue&type=style&index=0&id=3b82dc6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports